import { Button } from '@common/components/Button';
import Icon from '@common/components/Icon';
import styles from './IntegrationCard.module.scss';

interface IntegrationCardProps {
    title: string;
    subtitle: string;
    icon: string;
    status?: 'connected' | 'coming-soon' | 'available';
    onConnect?: () => void;
    onDisconnect?: () => void;
    isLoading?: boolean;
}

export default function IntegrationCard({
    title,
    subtitle,
    icon,
    status = 'available',
    onConnect,
    onDisconnect,
    isLoading = false
}: IntegrationCardProps) {
    const handleButtonClick = () => {
        switch (status) {
            case 'available':
                onConnect?.();
                break;
            case 'connected':
                onDisconnect?.();
                break;
            case 'coming-soon':
            default:
                // Do nothing for coming soon
                break;
        }
    };

    const getButtonText = () => {
        switch (status) {
            case 'connected':
                return 'Disconnect';
            case 'coming-soon':
                return 'Coming Soon';
            case 'available':
            default:
                return 'Connect';
        }
    };

    const getButtonVariant = () => {
        switch (status) {
            case 'connected':
                return 'outline';
            case 'coming-soon':
                return 'solid';
            case 'available':
            default:
                return 'solid';
        }
    };

    const getButtonColor = () => {
        switch (status) {
            case 'connected':
                return 'gray';
            case 'coming-soon':
                return 'gray';
            case 'available':
            default:
                return 'primary';
        }
    };

    const isDisabled = status === 'coming-soon';

    return (
        <div className={styles.integrationCard}>
            <div className={styles.cardHeader}>
                <Icon name={icon} size={24} />
                <h3 className={styles.cardTitle}>{title}</h3>
            </div>

            <p className={styles.cardDescription}>{subtitle}</p>

            <div className={styles.cardActions}>
                <Button
                    size="2"
                    variant={getButtonVariant()}
                    color={getButtonColor()}
                    disabled={isDisabled}
                    loading={isLoading}
                    onClick={handleButtonClick}
                    style={{ padding: '0px 40px' }}
                >
                    {getButtonText()}
                </Button>
            </div>
        </div>
    );
}